import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForwardCircleRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m0 13.6a6 6 0 1 1 0-12.2 6 6 0 0 1 0 12.2m-3.7-4 4.1-2.1-4.1-2zm4.1-4.2v4.2l4.2-2.1z" })
});
export default SvgForwardCircleRegularIcon;
